import axios from 'axios'
import Vue from 'vue'
import Router from 'vue-router'
import { Message, Loading } from 'element-ui';
import { getAccessToken } from './auth';
let loading;
let loadingNum = 0; //  内存中正在请求的数量
function startLoading() {
	if (loadingNum == 0) {
		loading = Loading.service({
			lock: true,
			text: '拼命加载中...',
			background: 'rgba(255,255,255,0.5)',
			target: document.querySelector('.content,.content1'),
		})
	}
	loadingNum++;
}
function endLoading() { //  关闭加载动画
	loadingNum--;
	if (loadingNum <= 0) {
		loading.close();
	}
}
const service = axios.create({
	baseURL: process.env.API_ROOT,
	responseType: 'json',
	withCredentials: true,
	timeout: 3*60 * 1000
})
service.interceptors.request.use(
	config => {
		startLoading(); //  打开加载动画
		var token = getAccessToken();
		config.headers = {
			"Authorization": token,
			'Content-Type': 'application/json' //配置请求头
		}
		if(config.method=='get'){
			if(config.data&&config.data.limit){
				if(config.data.limit){
					config.data['size'] = config.data.limit;
					delete config.data.limit;
				}
				if(config.data.page){
					config.data['current'] = config.data.page;
					delete config.data.page;
				}
			}
		}
		if(config.method=='post'){
			if(config.data&&config.data.limit){
				if(config.data.limit){
					config.data['size'] = config.data.limit;
					delete config.data.limit;
				}
				if(config.data.page){
					config.data['current'] = config.data.page;
					delete config.data.page;
				}
			}
		}
		return config
	}, error => {
		Promise.reject(error)
	}
)
service.interceptors.response.use(
	response => {
		endLoading();
		var data = response.config.data?JSON.parse(response.config.data):{};
		if(data.model == 'export'){
			return Promise.resolve(response.data)
		}else{
			if (response.status == 200) {
				if (response.data.code == 200) {
					return Promise.resolve(response.data.data);
				} else if (response.data.code == 401) {
					console.log(response.data)
					return Promise.reject(response.data)
				} else {
					return 
				}
			}
		}
	}, error => {
		endLoading();
		if(error.response.status==401){
			if(error.response.data.code==401){
				return Promise.reject(error.response.data)
			}
		}
		return 
	}
)
export default service



// WEBPACK FOOTER //
// ./src/utils/axios.js